/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserDrawerNotesContainer_viewer = {
    readonly id: string;
    readonly " $refType": "UserDrawerNotesContainer_viewer";
};
export type UserDrawerNotesContainer_viewer$data = UserDrawerNotesContainer_viewer;
export type UserDrawerNotesContainer_viewer$key = {
    readonly " $data"?: UserDrawerNotesContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"UserDrawerNotesContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDrawerNotesContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '8b9fa1c3e7efdcbb0188b5d262e83a8b';
export default node;
